export default {
  GET_REGION_DATA: '/nzjxcApi/Common/GetRegionCode'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/region/index.js